/* eslint-disable @typescript-eslint/no-empty-function */
import CardContainer from 'components/elements/CardContainer'
import LoadingArea from 'components/elements/LoadingArea'
import theme from 'stories/utils/theme'
import { SectionWide } from 'style'
import styled, { css } from 'styled-components'
import SideBarKnows from 'components/modules/Knows/SidebarKnows'
import _useTranslation from 'lib/hooks/_useTranslation'
import { getReferrerScreen } from 'lib/formatting/url'
import router from 'next/router'
import { Know } from 'interfaces/Know'
import KnowContent from './KnowContent'
import { Flashcard } from 'interfaces/Flashcard'
import { KnowSeoInfo } from 'interfaces/KnowSeoInfo'

const DesktopContainer = styled.div`
    background-color: ${theme.colors.white};
    @media (max-width: 1050px) {
        display: none;
    }
`

const DesktopWithSidebarLayout = styled.div<{ showSidebar?: boolean }>`
    display: grid;
    grid-template-columns: ${({ showSidebar }) => (showSidebar ? '2fr 1fr' : '1000px')};
    ${({ showSidebar }) =>
        !showSidebar
            ? css`
                  place-content: center;
              `
            : ''}
    grid-gap: 50px;

    @media (max-width: 1050px) {
        display: none;
    }
`

interface Props {
    loadingArea: string
    knowSeoInfo?: KnowSeoInfo | null
    similarKnows?: Know[] | null
    isOwner?: boolean
    flashcards?: Flashcard[] | null
}

const DesktopKnowSection = ({ knowSeoInfo, similarKnows, loadingArea, isOwner, flashcards }: Props) => {
    const { t } = _useTranslation('knows')
    const referrerScreen = getReferrerScreen(router)
    const showSidebar = !!similarKnows?.length

    const { know } = knowSeoInfo || {}

    return (
        <DesktopContainer>
            <SectionWide>
                <DesktopWithSidebarLayout showSidebar={showSidebar}>
                    <div>
                        <CardContainer
                            hideBorderRadius={false}
                            hasBorder={false}
                            hasShadow={false}
                            padding={0}
                            backgroundColor={theme.colors.white}
                        >
                            <LoadingArea area={loadingArea}>
                                {knowSeoInfo ? (
                                    <KnowContent
                                        knowSeoInfo={knowSeoInfo}
                                        isOwner={!!isOwner}
                                        onContentConversionBannerButtonClick={() => {}}
                                        referrerScreen={referrerScreen}
                                        showPreview
                                        flashcards={flashcards}
                                        downloadDeepLinkPath=""
                                        similarKnows={similarKnows || null}
                                    />
                                ) : null}
                            </LoadingArea>
                        </CardContainer>
                    </div>
                    {know && showSidebar ? (
                        <aside>
                            <SideBarKnows
                                parentKnow={know}
                                heading={t('knows/similarContentHeading')}
                                knows={similarKnows ?? []}
                                subject={know.subjects[0]}
                            />
                        </aside>
                    ) : null}
                </DesktopWithSidebarLayout>
            </SectionWide>
        </DesktopContainer>
    )
}

export default DesktopKnowSection
